import React from 'react'
import { Box, Divider } from '@mui/material';
import SingleHistory from './SingleHistory';

const SalesHistoryList = (props) => {



    return (
        <Box>
            {props.data.map((history) => (
                <React.Fragment key={history.id}>
                    <SingleHistory history={history} />
                    <Divider variant="middle" sx={{ my: 2 }} />
                </React.Fragment>
            ))}

        </Box>
    )
}

export default SalesHistoryList